import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSuccessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 12a7.999 7.999 0 1 1-15.998 0A7.999 7.999 0 0 1 20 12Z"
      stroke="#28BD61"
      strokeWidth={2}
    />
    <path
      d="m8.449 12.26 2.568 2.445 4.667-5.252"
      stroke="#28BD61"
      strokeWidth={2}
    />
  </svg>
);
const Memo = memo(SvgSuccessIcon);
export default Memo;
